
import {Component, Prop, Vue} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PriceHelper from "../../../../../../admin/js/helpers/priceHelper";
@Component({
  name: 'catalog-product-price'
})

export default class ProductPrice extends mixins(PriceHelper) {
  @Prop({default: () => []}) private productData: Array<object>;

  private get selectedProduct(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedProducts'];
  }

  private get isConfigurable(): boolean {
    return this.productData['product_type'] === 'configurable';
  }

  private get product(): Object {
    if (this.isConfigurable) {
      const selectedProducts = this.selectedProduct;
      if (selectedProducts && selectedProducts.length === 1) {
        return selectedProducts[0];
      }
    }

    return this.productData;
  }

  private get totalPrices(): number {
    return this.$store.getters['CatalogProduct/totalPrices'];
  }

  private get promotionEndTime(): string {
    if (this.product['special_price_end_date'] || null) {
      let date = new Date(this.product['special_price_end_date']);

      return date.toLocaleDateString('nl-NL');
    }

    return  '';
  }

  private get alternativePromotionEndTime(): string {
    if (this.product['alternative_special_to_date'] || null) {
      let date = new Date(this.product['alternative_special_to_date']);

      return date.toLocaleDateString('nl-NL');
    }

    return  '';
  }

  private get fromPrices(): number {
    return this.$store.getters['CatalogGroupedProduct/fromPrices'];
  }

  private get showAlternativePrices(): boolean {
    return false;
    if ((this.product['alternative_price'] || 0.00) === 0.00) {
      return false;
    }

    let altSpecialPrice = (this.product['alternative_special_price'] || 0.00) !== 0.00;

    return this.product['alternative_price'] !== this.product['final_price_incl_tax'] ||
      (altSpecialPrice && this.product['alternative_special_price'] !== this.product['final_price_incl_tax']);
  }
  private get isSpecialPrice(): boolean {
    return (this.product['final_price_incl_tax'] !== this.product['price_incl_tax']) ;
  }

}
